import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import DottedLoading from "../DottedLoading/DottedLoading";

const ConfirmationModal = ({
  show,
  onHide,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className="py-10 w-100" onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? <DottedLoading /> : confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
